import { gql } from '@apollo/client'

import { DISH_LIST_FRAGMENT } from '../fragments'

const DISHES_QUERY = gql`
  query dishes($filters: DishFiltersInput!, $pagination: PaginationInput!) {
    dishes(filters: $filters, pagination: $pagination) {
      total
      result {
        ...DishListFragment
      }
    }
  }
  ${DISH_LIST_FRAGMENT}
`

export default DISHES_QUERY
